import type { LucideIcon } from "lucide-react";

type Props = {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  mascot: string;
  /** Decorative emojis floating in the banner background */
  doodles?: string[];
  /** Tailwind gradient classes for the banner background */
  gradient: string;
};

export function PlayfulPageHeader({
  icon: Icon,
  title,
  subtitle,
  mascot,
  doodles = [],
  gradient,
}: Props) {
  return (
    <div
      className={`relative mb-6 overflow-hidden rounded-3xl border border-border p-6 shadow-sm animate-pop-in sm:p-8 ${gradient}`}
    >
      {/* floating background doodles */}
      {doodles.map((d, i) => (
        <span
          key={i}
          aria-hidden
          className="pointer-events-none absolute select-none text-3xl opacity-20 animate-float-y sm:text-4xl"
          style={{
            top: `${12 + ((i * 37) % 64)}%`,
            left: `${72 + ((i * 13) % 24)}%`,
            animationDelay: `${i * 0.4}s`,
          }}
        >
          {d}
        </span>
      ))}

      <div className="relative flex items-center gap-4 sm:gap-5">
        <div className="grid h-16 w-16 shrink-0 place-items-center rounded-2xl bg-background/70 text-4xl shadow-sm backdrop-blur animate-bob sm:h-20 sm:w-20 sm:text-5xl">
          {mascot}
        </div>
        <div className="min-w-0">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary/15 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary">
            <Icon className="h-3.5 w-3.5" />
            Mr Panda
          </span>
          <h1 className="mt-2 flex items-center gap-2 text-3xl font-extrabold tracking-tight text-foreground sm:text-4xl">
            <Icon className="hidden h-7 w-7 shrink-0 text-primary hover-wiggle sm:block" />
            {title}
          </h1>
          <p className="mt-1 text-sm text-muted-foreground sm:text-base">{subtitle}</p>
        </div>
      </div>
    </div>
  );
}